import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslate } from 'react-admin';
import NodeType from './nodeType';
import Application from './application'
import LinkedMenu from './linkedMenu';
import NodeLevel2 from './node-level-2';
import { NODE_NAMES } from '../utils';
import Preview from './Preview';
import DialogPreview from './dialog-preview-infopage';
import { IconButton as CustomizeIconButton, SourceIcon } from '../common/button';
import iconPreview from '../assets/icons/primary-blue-view.png';
import icWhiteView from '../assets/icons/white-view.png';
import { saveInfoPage as saveIP } from '../redux/actions/tree-action';

const useStyles = makeStyles(() => ({
    container: {
        width: 600,
        marginLeft: 150
    },
    nodeTitle: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '18px',
    },
}));

function RightContainer({ setConfirm, onCloseConfirm }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const translate = useTranslate();

    const { nodeSelected, saveInfoPage, isEditing, isDirty } = useSelector(state => state.tree);
    const [currentNodeLinkMenu, setCurrentNodeLinkMenu] = useState(nodeSelected);

    const showPreview = () => {
        if (isDirty) {
            setConfirm({
                open: true,
                title: translate('resources.infoPage.confirm_preview_title'),
                content: translate('resources.infoPage.confirm_preview_subtitle'),
                action: {
                    label: translate('pos.common.save'),
                    onClick: () => {
                        // onCloseConfirm();
                        // onSave(afterDialog);
                        dispatch(saveIP({ status: 'Saving' }));
                        onCloseConfirm();
                    },
                    onCancel: onCloseConfirm
                }
            });
        } else {
            dispatch(saveIP({ status: 'Saving' }));
        }
    }

    useEffect(() => {
        if (nodeSelected && nodeSelected.id > 0)
            setCurrentNodeLinkMenu(null);
    }, [nodeSelected?.id]);

    if (!nodeSelected) return null;
    return (
        <Box className={classes.container}>
            <DialogPreview
                open={saveInfoPage.status === 'Previewing'}
                onClose={() => dispatch(saveIP({ status: null }))}
            />
            <Box display='flex' mt={2} alignItems='center' justifyContent='space-between'>
                <Typography className={classes.nodeTitle}>{nodeSelected.nodeName}</Typography>
                <CustomizeIconButton
                    disabled={!isEditing}
                    secondary
                    label={translate('resources.infoPage.btnPreview')}
                    onClick={showPreview}
                    endIcon={<SourceIcon source={!isEditing ? icWhiteView : iconPreview} />}
                />
            </Box>
            {
                nodeSelected.nodelevel ? (
                    <Fragment>
                        <NodeType />
                        {nodeSelected.applicationData.nodeType === NODE_NAMES.APPLICATION && <Application />}
                        {nodeSelected.applicationData.nodeType === NODE_NAMES.LINKED_MENU && <LinkedMenu setCurrentNodeLinkMenuFunc={setCurrentNodeLinkMenu} />}
                        <Preview isLinkedMenu={nodeSelected.applicationData.nodeType === NODE_NAMES.LINKED_MENU} isContact={nodeSelected.applicationData.nodeType === NODE_NAMES.CONTACT} currentNodeLinkMenu={nodeSelected.applicationData.nodeType === NODE_NAMES.LINKED_MENU ? currentNodeLinkMenu : null} />
                    </Fragment>
                ) : <NodeLevel2 />
            }
        </Box>
    );
}

RightContainer.propTypes = {
    setConfirm: PropTypes.func.isRequired,
    onCloseConfirm: PropTypes.func.isRequired,
};

export default RightContainer;
